import React from "react";
import FormLayout from '../FormLayout';
import FormLayoutField from '../FormLayoutField';
import { Field } from 'redux-form'
import Utils from '../../services/Utils';

/** Class representing a PDF layout custom text field. */
class TextField extends FormLayoutField {

    constructor(properties) {
        super({
            ...(TextField.getDefaultOptions()),
            ...properties,
        });

        this.type = FormLayout.TEXT;
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = super.getDefaultOptions();

        properties.placeholder = {};

        return properties;
    }

    /**
     * Return the list of options this field handles
     */
    getHandledOptions() {
        return super.getHandledOptions().concat([
            FormLayout.OPTION_PLACEHOLDER,
        ]);
    }

    /**
     * Return this field preview as JSX string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getPreview(props) {
        return (
            <div className="field-wrapper form-group">
                { this.getPreviewLabel(props) }
                { this.getDescription(props) }
                <div className="input">{ this.getPreviewInput(props) }</div>
            </div>
        );
    }

    /**
     * Render this field input
     *
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getInput(props) {
        const placeholderText = Utils.localized_or_fallback(
            this.placeholder, props?.lang, ''
        );

        return (
            <Field
                component="input"
                type="text"
                name={this.reduxFieldName(props)}
                required={this.htmlRequired(props)}
                className="form-control"
                placeholder={placeholderText || undefined}
            />
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'comment-o';
    }
}

export default TextField;
